import React from "react";

const QueueManager = () => <div className="content"><h2>Queue Manager</h2></div>;

export default QueueManager; 